import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const ActionIcons = styled(Box)`
  button {
    margin: 0 5px;
  }
  margin-left: auto;
  display: flex;
  flex: 0;
`;
